export const API_KEY = process.env.REACT_APP_API_KEY;

export const baseUrl = 'https://developers.zomato.com/api/v2.1';
